// src/pages/Login.js
import React from 'react';
import LoginGrid from '../components/LoginGrid';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Box } from '@material-ui/core';

export default function Login() {
    return (
        <>
            <NavBar />
            <Box
                style={{
                    minHeight: 'calc(100vh - 64px - 100px)', // viewport - navbar - footer
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px 0'
                }}
            >
                <LoginGrid />
            </Box>
            <Footer />
        </>
    );
}